<template>
  <DrupalLink :to="url" class="block relative size-full group">
    <MediaImage
      v-if="image"
      v-bind="image"
      :style-name="styleName"
      class="h-full"
    />
    <div
      class="max-w-2xl 3xl:max-w-3xl px-30 md:px-80 lg:px-100 absolute z-0 inset-0 size-full"
    >
      <div
        class="group-hover:opacity-60 absolute z-10 bottom-20 left-20 pl-15 pt-10 pb-5 border-l border-white lg:border-l-3 text-white"
      >
        <h3 class="is-3">{{ title }}</h3>
      </div>
    </div>
  </DrupalLink>
</template>

<script lang="ts" setup>
import type { MediaImageFragment } from '#graphql-operations'
import type { LegacyImageStyle } from '~/helpers/imageStyles'

withDefaults(
  defineProps<{
    title?: string
    url: string
    image?: MediaImageFragment
    styleName?: LegacyImageStyle
  }>(),
  {
    styleName: 'teaser_one',
    image: undefined,
    title: undefined,
  },
)

defineOptions({
  name: 'TeaserBox',
})
</script>
